import { render, staticRenderFns } from "./RemoveFilter.vue?vue&type=template&id=d5164332"
import script from "./RemoveFilter.vue?vue&type=script&lang=js"
export * from "./RemoveFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports